import { get as get$1, post as post$1 } from "./fetchApi.mjs";
import { CommonUtils } from "fx-front-utils";
let axiosInst;
const configAxios = (inst) => {
  axiosInst = inst;
};
async function get(url, data = {}, init = {}) {
  if (axiosInst) {
    let getUrl = "";
    if (!Object.keys(data).length) {
      getUrl = url;
    } else {
      getUrl = url + "?" + new URLSearchParams(data).toString();
    }
    return new Promise((resolve, reject) => {
      axiosInst.request({
        url: getUrl,
        method: "GET",
        data: null,
        ...init
      }).then((response) => {
        if (response.data instanceof ArrayBuffer) {
          CommonUtils.handleFileBuffer(response);
          resolve({ code: 0, data: true, desc: "\u4E0B\u8F7D\u6210\u529F" });
        } else {
          resolve(response.data);
        }
      }, (err) => {
        reject(err);
      });
    });
  } else {
    return get$1(url, data, init);
  }
}
async function post(url, data, init = {}) {
  if (axiosInst) {
    return new Promise((resolve, reject) => {
      axiosInst.request({
        url,
        method: "POST",
        data,
        ...init
      }).then((response) => {
        resolve(response.data);
      }, (err) => {
        reject(err);
      });
    });
  } else {
    return post$1(url, data, init);
  }
}
export { configAxios, get, post };
